export default function action(state, payload) {
  const timestamp = new Date().getTime()
  const index = state.queue.findIndex(i => i.questionId === payload.questionId)
  if (index > -1) state.queue[index] = {...payload, timestamp}
  else state.queue.push({...payload, timestamp})
  return {
    ...state,
  }
}
